import React from 'react';
import PropTypes from 'prop-types';
import TranslationContainer from '../translation/translation_container';
import Submit from '../form/floating_label/submit';
import Translation from '../translation/translation';
import { removeVehicleDetailsData } from '../../../_views/vehicle_configurator/set_vehicle_data';
import TextArea from '../form/floating_label/textarea';
import { resetConfiguratorData } from '../../../_views/configurator_buttons/configurator_buttons';
import CheckoutConfiguratorAnalytics from '../../../_modules/google_analytics/checkout_configurator';
import { applyFilters } from '../../helper/apply_filters';

function VehicleNotProvidedLayer(props) {
    const { filters, onChange, fromCheckboxLayer, fromTyreSize } = props;

    const unsetVehicle = (e) => {
        e.preventDefault();

        CheckoutConfiguratorAnalytics.cannotProvideVehicleSubmittedClickAction(filters.vehicleNotProvidedComment);

        removeVehicleDetailsData(filters.vehicleNotProvidedComment).then(res => {
            resetConfiguratorData();
            if (fromTyreSize) {
                applyFilters('tyre');
            }
        });
    };

    return (
        <span style={fromCheckboxLayer ? { textAlign: 'left' } : {}}>
            {!fromCheckboxLayer && <div className="rego-lookup-configurator-input-layer-header">
                <Translation translationKey={'rego-lookup-input-layer-header-text-v2'} />
            </div>
            }
            <div className="rego-lookup-configurator-input-layer-sub-header" style={fromCheckboxLayer ? { marginTop: '30px' } : {}}>
                <Translation translationKey={'rego-lookup-cant-provide-vehicle-layer-content-text-v2'} />
            </div>
            <form className="rego-lookup-configurator-section" style={{ paddingBottom: '25px' }} onSubmit={(e) => {
                e.preventDefault();
            }}>
                <div className="rego-lookup-section rego-lookup-input-section">
                    <TranslationContainer
                        targetProperties={{
                            label: { translationKey: 'rego-lookup-cant-provide-vehicle-layer-comment-label-v2' }
                        }}
                    >
                        <TextArea name="vehicleNotProvidedComment"
                            label="will-be-replaced"
                            onChange={onChange}
                            maxLength="150"
                            value={filters.vehicleNotProvidedComment}
                        />
                    </TranslationContainer>
                </div>

                <div>
                    <TranslationContainer
                        targetProperty="label"
                        translationKey={'vehicle-configurator-can-not-provide-vehicle-button'}>
                        <Submit
                            onSubmit={unsetVehicle}
                            label="will-be-replaced"
                            call-to-action={false}
                        />
                    </TranslationContainer>
                </div>
            </form>
        </span>
    );
}

VehicleNotProvidedLayer.propTypes = {
    filters: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default VehicleNotProvidedLayer;
